'use strict';

/* Services */

angular.module('substoreApp.services', ['ngResource', 'ngCookies']);